if ('NodeList' in window && !NodeList.prototype.forEach) {
  console.info('polyfill for IE11')
  NodeList.prototype.forEach = function (callback, thisArg) {
    thisArg = thisArg || window
    for (let i = 0; i < this.length; i++) {
      callback.call(thisArg, this[i], i, this)
    }
  }
}

;(function () {
  /*
        HOME ARROW
        $('.arrow-home').click(function(event) {
            $('body, html').animate({
                scrollTop: $(window).height()-$('header').outerHeight()*2},
                800, 'easeOutExpo');
        });
    */

  // Remove empty <p> tags created by tinymce
  const paragraph = document.querySelectorAll('p') || []
  paragraph.forEach((e) => e.innerHTML.trim() === '' && e.parentNode.removeChild(e))

  $('.sym-slides').slick({
    accessibility: true,
  })

  $('.venues-slider-block').slick({ lazyLoad: 'ondemand', accessibility: false, fade: true, adaptiveHeight: true })
  // .on('beforeChange', function (event, slick, currentSlide, nextSlide) {
  //   let containerTag = slick.$slider.closest('[data-tb-tag]')

  //   if (containerTag.length > 0) {
  //     let pinActive = containerTag[0].querySelectorAll('[data-index].mapNumber.active')

  //     pinActive.forEach((pin) => {
  //       pin.classList.remove('active')
  //     })

  //     let pinNext = containerTag[0].querySelector(`[data-index='${nextSlide}'].mapNumber`)

  //     if (pinNext !== null) {
  //       pinNext.classList.add('active')
  //     }
  //   }
  // })

  const onRemove = (nodeList, className) => {
    if (nodeList === null || nodeList.length === 0) return null

    if (nodeList instanceof HTMLElement) {
      if (nodeList.classList.contains(className)) nodeList.classList.remove(className)
    } else {
      nodeList.forEach((node) => {
        if (node.classList.contains(className)) node.classList.remove(className)
      })
    }
  }

  const onAdd = (nodeList, className) => {
    if (nodeList === null || nodeList.length === 0) return null

    if (nodeList instanceof HTMLElement) {
      if (!nodeList.classList.contains(className)) nodeList.classList.add(className)
    } else {
      nodeList.forEach((node) => {
        if (!node.classList.contains(className)) node.classList.add(className)
      })
    }
  }

  const tabsVenues = () => {
    // filter by select
    let selectFilter = document.querySelectorAll('[data-tb-select="container"]')

    selectFilter.forEach((select) => {
      select.addEventListener('change', (event) => {
        let target = event.target
        let quad = target.closest('[data-tb-quad]')

        if (target && target.value !== '') {
          let tagTarget = target.value

          onAdd(quad.querySelectorAll('[data-tab][data-content-tab]:not(.hidden)'), 'hidden')
          onRemove(quad.querySelectorAll(`[data-tab][data-content-tab='${tagTarget}'].hidden`), 'hidden')

          // slick to position 0
          $('.venues-slider-block').slick('setPosition')
          $('.venues-slider-block').slick('slickGoTo', 0)
        }
      })
    })

    let tabsList = document.querySelectorAll('[data-tb-tabs="container"]')

    tabsList.forEach((tabs) => {
      tabs.addEventListener('click', (event) => {
        let target = event.target
        let quad = target.closest('[data-tb-quad]')

        if (target && target.hasAttribute('data-tag')) {
          let tagTarget = target.getAttribute('data-tag')

          onRemove(tabs.querySelectorAll('[data-tag].active'), 'active')
          onAdd(quad.querySelectorAll('[data-tab][data-content-tab]:not(.hidden)'), 'hidden')

          onAdd(target, 'active')
          onRemove(quad.querySelectorAll(`[data-tab][data-content-tab='${tagTarget}'].hidden`), 'hidden')

          // slick to position 0
          $('.venues-slider-block').slick('setPosition')
          $('.venues-slider-block').slick('slickGoTo', 0)
        }
      })
      // let tabsContent = tabs.querySelector('[data-tag]')
    })

    // sub tabs
    let subTabsList = document.querySelectorAll('[data-tb-subtabs="container"]')

    subTabsList.forEach((tabs) => {
      tabs.addEventListener('click', (event) => {
        let target = event.target
        let quad = target.closest('.map')

        if (target && target.hasAttribute('data-tag')) {
          event.preventDefault()

          let tagTarget = target.getAttribute('data-tag')

          onRemove(tabs.querySelectorAll('[data-tag].active'), 'active')
          onAdd(quad.querySelectorAll('[data-map-tab]:not(.hidden)'), 'hidden')

          onAdd(target, 'active')
          onRemove(quad.querySelectorAll(`[data-map-tab='${tagTarget}'].hidden`), 'hidden')

          // toggle mark of map
          onAdd(quad.querySelectorAll(`[data-content-tab]:not(.hidden) [data-mark-tab]:not(.hide)`), 'hide')
          onRemove(quad.querySelectorAll(`[data-content-tab]:not(.hidden) [data-mark-tab="mark-map_${tagTarget}"]`), 'hide')
        }
      })
    })

    // slick to go of mark
    let marksToSlick = document.querySelectorAll('[data-slick-to-go][data-mark-tab]')
    marksToSlick.forEach((toSlick) => {
      toSlick.addEventListener('click', (event) => {
        let target = event.target

        if (target) {
          let numberToGo = target.getAttribute('data-slick-to-go')
          $('.venues-slider-block').slick('slickGoTo', numberToGo)
        }
      })
    })
  }

  tabsVenues()

  //COLUMNS FILTER
  let columns_filter_select = document.getElementById('filter-columns')
  let columns_items = document.querySelectorAll('.three-columns__item')

  if (columns_filter_select !== null) {
    columns_filter_select.addEventListener('change', () => {
      console.log(columns_filter_select.value)
      let value = columns_filter_select.value

      for (let i = 0; i < columns_items.length; i++) {
        const item = columns_items[i]

        if (value !== 'all') {
          if (!item.classList.contains(value)) {
            item.classList.add('hidden')
          } else {
            item.classList.remove('hidden')
          }
        } else {
          item.classList.remove('hidden')
        }
      }
    })
  }
  //END COLUMNS FILTER

  //MOBILE NAVIGATION TOOGLE ACTIVE CLASS
  const onToggle = (nodeSelector, selector, className) => {
    if (nodeSelector === null || nodeSelector === '' || selector === '' || className === '') return null

    nodeSelector.addEventListener('click', () => {
      let mobileNav = document.querySelector(selector)

      if (mobileNav !== null) {
        mobileNav.classList.toggle(className)
      }
    })
  }

  onToggle(document.querySelector('.js-open-menu'), '#menu-mobile', 'show')
  onToggle(document.querySelector('.js-close-menu-mobile'), '#menu-mobile', 'show')
})()
